import React from 'react';
import { connect } from 'react-redux';
import { Table } from 'semantic-ui-react';
import RowDeleteButton from '@/components/buttons/RowDeleteButton';
import { deleteLookupItem } from '../../dictionaries/actions';

const LookupDeleteTableCell = ({ lookupItemUUID, deleteRow }) => (
  <Table.Cell collapsing textAlign="center">
    <RowDeleteButton entity="lookup" onClick={() => deleteRow(lookupItemUUID)} />
  </Table.Cell>
);

const mapDispatchToProps = {
  deleteRow: deleteLookupItem,
};

export default connect(null, mapDispatchToProps)(LookupDeleteTableCell);
